module.exports = __webpack_public_path__ + "static/media/game_cover_rhythm@768.c10d3e4b.png";